// filterConfig.js
//
// ════════════════════════════════════════════════════════════
// VISIBILITY RULES:
//
//   is_show: false             → never renders
//   show_for_kind: []          → show for ALL listing_kind values
//   show_for_kind: ["property"]→ show ONLY when listing_kind matches
//   show_for_category: []      → show for ALL categories
//   show_for_category: [1,3]   → show ONLY when those category ids selected
//
//   type:
//     "radio"       → pill group (single select)
//     "multi_drop"  → custom multi-select dropdown
//     "range_slider"→ dual handle drag slider
//     "dropdown"    → single select native dropdown
//
// ════════════════════════════════════════════════════════════

const filterConfig = [

  // ── 1. Listing Kind ───────────────────────────────────────
  {
    id: 1,
    key: "listing_kind",
    label: "Listing Kind",
    type: "radio",
    is_show: true,
    show_for_kind: [],
    show_for_category: [],
    options: [
      { value: "all",      label: "All"      },
      { value: "property", label: "Property" },
      { value: "project",  label: "Project"  },
    ],
    default: "all",
    url_key: "kind",
  },

  // ── 2. Rent / Sale — hidden for project ───────────────────
  {
    id: 2,
    key: "listing_type",
    label: "Listing Type",
    type: "radio",
    is_show: true,
    show_for_kind: ["all", "property"],
    show_for_category: [],
    options: [
      { value: "all",  label: "All"  },
      { value: "sale", label: "Sale" },
      { value: "rent", label: "Rent" },
    ],
    default: "all",
    url_key: "type",
  },

  // ── 3. Type → cascades category, hidden for project ───────
  {
    id: 3,
    key: "property_type",
    label: "Type",
    type: "radio",
    is_show: true,
    show_for_kind: ["all", "property"],
    show_for_category: [],
    options: [
      { value: "all",         label: "All"         },
      { value: "residential", label: "Residential" },
      { value: "commercial",  label: "Commercial"  },
    ],
    default: "all",
    url_key: "ptype",
    type_category_map: {
      residential: [1, 3, 5],
      commercial:  [2, 4, 5],
    },
  },

  // ── 4. Category (filtered by type) ────────────────────────
  {
    id: 4,
    key: "category_id",
    label: "Property Category",
    type: "multi_drop",
    is_show: true,
    show_for_kind: [],
    show_for_category: [],
    options: "from_categorys",
    url_key: "cat",
    placeholder: "All Categories",
  },

  // ── 5. BHK — Apartment(1) / Villa(3) only ─────────────────
  {
    id: 5,
    key: "bhk",
    label: "BHK",
    type: "multi_drop",
    is_show: true,
    show_for_kind: ["all", "property"],
    show_for_category: [1, 3],
    options: [
      { value: "1 BHK", label: "1 BHK" },
      { value: "2 BHK", label: "2 BHK" },
      { value: "3 BHK", label: "3 BHK" },
      { value: "4 BHK", label: "4 BHK" },
      { value: "5 BHK", label: "5 BHK" },
    ],
    url_key: "bhk",
    placeholder: "Any BHK",
  },

  // ── 6. Price Range Slider ─────────────────────────────────
  {
    id: 6,
    key: "price",
    label: "Price Range",
    type: "range_slider",
    is_show: true,
    show_for_kind: [],
    show_for_category: [],
    min: 0,
    max: 100000000,
    url_key_min: "pmin",
    url_key_max: "pmax",
  },

  // ── 7. Land Area — Plot/Land(5) + Others(6) ───────────────
  {
    id: 7,
    key: "land_area",
    label: "Land Area (sqft)",
    type: "range_slider",
    is_show: true,
    show_for_kind: [],
    show_for_category: [5, 6],
    min: 0,
    max: 10000,
    url_key_min: "lamin",
    url_key_max: "lamax",
  },

  // ── 8. Amenities ──────────────────────────────────────────
  {
    id: 8,
    key: "amenities_id",
    label: "Amenities",
    type: "multi_drop",
    is_show: true,
    show_for_kind: ["all", "property"],
    show_for_category: [],
    options: "from_aminities",
    url_key: "am",
    placeholder: "Any Amenities",
  },

  // ── 9. New / Resale ───────────────────────────────────────
  {
    id: 9,
    key: "sales_type",
    label: "Property Status",
    type: "multi_drop",
    is_show: true,
    show_for_kind: ["all", "property"],
    show_for_category: [],
    options: [
      { value: "New Property", label: "New Property" },
      { value: "Resale",       label: "Resale"       },
    ],
    url_key: "sale",
    placeholder: "Any Status",
  },

  // ── 10. Facing Direction ──────────────────────────────────
  {
    id: 10,
    key: "direction",
    label: "Facing",
    type: "multi_drop",
    is_show: true,
    show_for_kind: [],
    show_for_category: [],
    options: [
      { value: "North",      label: "North"      },
      { value: "South",      label: "South"      },
      { value: "East",       label: "East"       },
      { value: "West",       label: "West"       },
      { value: "North East", label: "North East" },
      { value: "North West", label: "North West" },
      { value: "South East", label: "South East" },
      { value: "South West", label: "South West" },
    ],
    url_key: "dir",
    placeholder: "Any Direction",
  },

  // ── 11. Sort By — NO "Default" option ────────────────────
  //    First option (price_asc) is treated as no-sort when nothing selected
  {
    id: 11,
    key: "sort",
    label: "Sort By",
    type: "dropdown",
    is_show: true,
    show_for_kind: [],
    show_for_category: [],
    options: [
      { value: "price_asc",  label: "Price: Low → High" },
      { value: "price_desc", label: "Price: High → Low" },
      { value: "newest",     label: "Newest First"      },
    ],
    // no default → empty = no sort applied (natural order)
    url_key: "sort",
    placeholder: "Sort By",     // shown when nothing selected
  },

  // ── 12. State ─────────────────────────────────────────────
  {
    id: 12,
    key: "state_id",
    label: "State",
    type: "dropdown",
    is_show: true,
    show_for_kind: [],
    show_for_category: [],
    options: "from_states",
    url_key: "state",
  },

  // ── 13. City ──────────────────────────────────────────────
  {
    id: 13,
    key: "city_id",
    label: "City",
    type: "dropdown",
    is_show: true,
    show_for_kind: [],
    show_for_category: [],
    options: "from_cities",
    url_key: "city",
  },

];

export default filterConfig;